export default {
  token_already_exists: 'Asset already exists in system. Try to change Asset code'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/errors.js